var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-the-c01-form-note-panel-gift-card"},[(
      _vm.isGiftCardAndNormalItemInCart ||
        _vm.isWebCouponAndNormalItemInCart ||
        _vm.isGiftCardAndWebCouponItemInCart ||
        _vm.isWebCouponAndGiftItemInCart
    )?[_c('div',{staticClass:"p-the-c01-form-note-panel-gift-card__content"},[_vm._v(" ギフトコードは、他の商品と一緒に申込みできません。 ")])]:_vm._e(),(
      _vm.isNormalItemAndGiftCardInCart || _vm.isBenepoExchangeAndSomethingsInCart
    )?[_c('div',{staticClass:"p-the-c01-form-note-panel-gift-card__content p-the-c01-form-note-panel-gift-card__content--wide"},[_vm._v(" こちらの商品は、カートの商品と一緒に申込みすることができません。 カートの商品をお申込みの上、再度カートに入れていただくか、カートの商品を削除してください。 ")])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }